// Contact information
export const CONTACT_EMAIL = "contact@agentreacher.com";
export const PRIVACY_EMAIL = "privacy@agentreacher.com";
export const SUPPORT_EMAIL = CONTACT_EMAIL;

// Social links
export const SOCIAL_LINKS = {
	email: `mailto:${CONTACT_EMAIL}`,
} as const;

// Company info
export const COMPANY_NAME = "AgentReacher";
export const COMPANY_DOMAIN = "agentreacher.com";
